module.exports = __webpack_public_path__ + "static/media/Army in the Pews.34aa72da.docx";